import * as React from "react";
import { ErrorBoundary } from "react-error-boundary";
import usePluginEntities from "hooks/usePluginEntities";
const MessageDetailProviders = ({ children, message }) => {
  const contextProviders = usePluginEntities("views.components.widgets.messageDetails.contextProviders");
  if (!contextProviders || (contextProviders == null ? void 0 : contextProviders.length) === 0) {
    return children;
  }
  return contextProviders.reduce(
    (nestedChildren, MessageDetailContextProvider) => /* @__PURE__ */ React.createElement(ErrorBoundary, { FallbackComponent: () => nestedChildren }, /* @__PURE__ */ React.createElement(MessageDetailContextProvider, { message }, nestedChildren)),
    children
  );
};
export default MessageDetailProviders;
